import { CfCardGenericProps } from "./schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import {
  convertCfImageProps,
  convertSingleImage,
} from "components/Image/CfImage";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import CardGeneric, { CardGenericProps } from "..";
import CfAnchor from "components/Anchor";
import Image from "components/Image";
import Markdown from "react-markdown";
import React from "react";

export const convertCfCardGenericProps = ({
  cardImage,
  title,
  description,
  theme,
  ctaLabel,
  cardAnchor,
  centered,
  promo,
  contentful_id,
}: CfCardGenericProps) => {
  const updatedDescription =
    description && typeof description !== "string"
      ? description?.description
      : description;

  let image;

  if (cardImage) {
    const singleImage = convertSingleImage({
      image: cardImage,
    });
    image = singleImage ? (
      <Image {...convertCfImageProps(singleImage)} />
    ) : undefined;
  }

  const liveInspector: LiveInspectorData = {
    card: ContentfulLivePreview.getProps({
      entryId: contentful_id,
      fieldId: "entryTitle",
    }),
  };

  const props: CardGenericProps = {
    ctaLabel: ctaLabel || undefined,
    description: updatedDescription ? (
      <Markdown>{updatedDescription}</Markdown>
    ) : undefined,
    title: title || undefined,
    isCentered: !!centered,
    isPromo: !!promo,
    variant: theme,
    customClass: cardAnchor ? "elevation-card cursor-pointer" : "",
    ...(image && { image }),
    liveInspector,
  };
  return props;
};

const CfCardGeneric = (props: CfCardGenericProps) => {
  const liveProps = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  return (
    <CfAnchor {...props.cardAnchor}>
      <CardGeneric {...convertCfCardGenericProps(liveProps)} />
    </CfAnchor>
  );
};

export default CfCardGeneric;
